// Shared helpers for the shop navbar ticker (AnnouncementTicker).

import { announcementShowsBanner } from './announcementDisplayStorage';

export const LSC_TICKER_HEIGHT_PX = 36;
export const LSC_TICKER_MOTION_MS = 420;
export const LSC_TICKER_OPEN_CLASS = 'lsc-ticker-open';

/** Class + length token. Works without CSS @property (Safari). Chrome still animates when @property is present. */
export function applyTickerOpenClass(open, root) {
    const el = root || (typeof document !== 'undefined' ? document.documentElement : null);
    if (!el || !el.classList || !el.style) return;
    const on = Boolean(open);
    el.classList.toggle(LSC_TICKER_OPEN_CLASS, on);
    el.style.setProperty('--lsc-ticker-h', on ? `${LSC_TICKER_HEIGHT_PX}px` : '0px');
}

/** Shell phases for enter / leave without a snap unmount. */
export function stepTickerPresence(phase, wantOpen) {
    if (wantOpen) {
        if (phase === 'out' || phase === 'leave') return 'enter';
        return phase === 'enter' ? 'enter' : 'in';
    }
    if (phase === 'out') return 'out';
    if (phase === 'leave') return 'leave';
    return 'leave';
}

/** Guest audience when nobody is signed in (targeting off = everyone). */
export function tickerAudienceFromUser(userDoc) {
    if (!userDoc) {
        return { role: 'Guest', Pricing: 'a' };
    }
    return userDoc;
}

export function isAnnouncementUnexpired(data, isoDate) {
    if (!data) return false;
    if (data.active === false) return false;
    if (data.expiryDate && isoDate && data.expiryDate < isoDate) return false;
    return true;
}

/** Title then message, single line for the marquee. */
export function formatTickerItemText(data) {
    const title = String(data?.title || '').replace(/\s+/g, ' ').trim();
    const message = String(data?.message || '').replace(/\s+/g, ' ').trim();
    if (title && message) return `${title}  ${message}`;
    return title || message;
}

export function tickerLoopDurationSec(textLength) {
    const n = Number(textLength) || 0;
    return Math.max(22, Math.min(90, Math.round(n * 0.09)));
}

/**
 * Active banner-channel announcements, minus session-hidden ids.
 * Caller applies `matchesTargeting` for the current audience.
 */
export function buildTickerItems(announcements, options = {}) {
    const isoDate = options.isoDate || '9999-12-31';
    const hidden = new Set(options.hiddenIds || []);

    const items = [];
    (announcements || []).forEach((raw) => {
        const data = raw || {};
        const id = data.id;
        if (!id) return;
        if (hidden.has(id)) return;
        if (!isAnnouncementUnexpired(data, isoDate)) return;
        if (!announcementShowsBanner(data)) return;

        const text = formatTickerItemText(data);
        if (!text) return;

        items.push({
            id,
            text,
            ctaText: String(data.ctaText || '').trim(),
            ctaLink: String(data.ctaLink || '').trim(),
            priority: data.priority || 1,
        });
    });

    items.sort((a, b) => (b.priority || 1) - (a.priority || 1));
    return items;
}
